import React from "react";

const ServiceSlider = ({ imgs, content,classname, title, maincontent }) => {
  return (
    <>
      <div className="sm:h-[450px]">
        <div className={classname}>
          <div className="sm:mx-auto sm:py-20 py-2 px-3 sm:w-[60%] ">
            <p className="font-roboto   text-3xl  py-2">{title}</p>
            <p className="font-roboto sm:text-xl  text-base py-3">{content}</p>
            <p className="font-roboto  text-base md:text-lg text-justify "> {maincontent}</p>
          </div>
          <div className="  mx-auto py-10 ">
            <img src={imgs} alt="images" className="border-black border-2-solid rounded-2xl mx-auto pb-2 h-[400px] w-[400px]"/>
          </div>
        </div>
      </div>
    </>
  );
};

export default ServiceSlider;
